import * as React from 'react';
import { useAppDispatch, useAppSelector } from '../../store';
import { choiceActionCreators } from '../../store/Choice';
import { trainingActionCreators } from '../../store/Training';
import { ChoiceValue, CardOption } from '../../types/TrainingTypes';
import PhraseColoring from '../card/PhraseColoring';
import ChoiceOptions from './ChoiceOptions';
import getBorderColor from './borderColor';
import Example from './Example';

export default function Choice() {
    const trainingState = useAppSelector(state => state.training);
    const state = useAppSelector(state => state.choice);
    const dispatch = useAppDispatch();
    const [isTimerActive, setIsTimerActive] = React.useState(false);
    let borderColor = getBorderColor(trainingState.card?.resultInfo?.reviews);

    function nextCard() {
        dispatch(trainingActionCreators.nextCard());
    }

    function chooseOption(option: CardOption | undefined, isLong: boolean) {
        if (!isTimerActive) {
            const isCorrect = option?.content === state.solution;
            if (trainingState.isSolutionShown) {
                if (option?.content === state.solution || !trainingState.isServicePanelEnabled)
                    nextCard();
            }
            else {
                if (isCorrect && !trainingState.isServicePanelEnabled) {
                    setIsTimerActive(true);
                    setTimeout(() => {
                        setIsTimerActive(false);
                        nextCard();
                    }, 300);
                }
                dispatch(choiceActionCreators.chooseOption(option));

                const assessmentValue = isCorrect
                    ? isLong
                        ? ChoiceValue.Know
                        : ChoiceValue.Correct
                    : isLong
                        ? ChoiceValue.Decrease
                        : ChoiceValue.Incorrect;
                const time = new Date().getTime() - new Date(state.shownTime!).getTime();

                let difficulty = Math.min(20, (6 + state.task.length));
                let correctOptionPassed = false;
                for (let i = 0; i < state.options.length; i++) {
                    difficulty += (Math.min(20, (6 + state.options[i].content.length)) * (correctOptionPassed ? 0.6 : 1));
                    correctOptionPassed ||= (state.options[i].content === option?.content);
                }
                dispatch(trainingActionCreators.choiceAssess(assessmentValue, time, Math.round(difficulty)));
            }
        }
    }

    function resetTimer() {
        dispatch(choiceActionCreators.resetTimer());
    }

    return (
        <div className="flex-grow-1 w-100 width-limit text-break">

            <div className="training-box-tasks">
                <div className="training-box"
                    style={{ borderColor: borderColor }}>
                    <div>
                        <span className="task">
                            <PhraseColoring phrase={state.task} phraseColoring={state.taskColoring} />
                        </span>
                        {state.taskAux &&
                            <>
                                <br />
                                <span className="text-secondary"> {state.taskAux}</span>
                            </>
                        }
                        {state.taskForms &&
                            <>
                                <br />
                                <span className="text-secondary"> {state.taskForms}</span>
                            </>
                        }
                    </div>
                </div>

                {state.example &&
                    <div className="example training-box mt-2">
                        <Example example={state.example} phrase={trainingState.card!.phrase} language={trainingState?.card?.modeInfo?.wiktionaryLanguage} />
                    </div>
                }
            </div>

            <div className="mt-2">
                <ChoiceOptions options={state.options}
                    backgrounds={state.backgrounds}
                    chooseOption={chooseOption} />

                {state.wrongOption &&
                    <div className="fs-5 mt-2"><span className="red">{state.wrongOption.content}</span> - <span className="fw-bold">{state.wrongOption.wrongOption}</span></div>
                }
            </div>
        </div>
    );
}
